import {GET_INNER_INVOICE_LIST, GET_INVOICE_BY_ID, GET_OUTER_INVOICE_LIST } from './ApiConstants';
import api from './ApiHandler';

export const getInvoiceByPage = async (payload: any) => {
  return await api.get(GET_OUTER_INVOICE_LIST, { params: payload });
};

export const getInnerInvoicesInnerTable = async (payload: any) => {
  return await api.get(GET_INNER_INVOICE_LIST, { params: payload });
};

export const getInvoicesById = async (payload: any) => {
  return await api.get(GET_INVOICE_BY_ID, { params: payload });
};
